import React from 'react';
import TagManager from 'react-gtm-module';
import { ToastContainer } from 'react-toastify';

import { setLocalProgram } from 'services/localStorage';
import { cnhPop } from 'utils/program';

import ConfirmModal from './components/ConfirmModal';
import ErrorBoundary from './components/ErrorBoundary';
import Routes from './routes';
import GlobalStyle from './styles/global';
import Voucher from 'components/Voucher';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID,
};

TagManager.initialize(tagManagerArgs);

export default function App() {
  let defaultProgram = cnhPop;
  let program = 'cnhpop';

  const popDomains = process.env.REACT_APP_POP_HOSTNAME.split(';');

  const host = window.location.hostname;
  if (popDomains && popDomains.indexOf(host) >= 0) {
    program = 'cnhpop';
    defaultProgram = cnhPop;
  }
  setLocalProgram(defaultProgram);

  return (
    <>
      <ToastContainer autoClose={5000} />
      <ConfirmModal program={program} />
      <ErrorBoundary>
        <Routes program={program} />
        <GlobalStyle program={program} />
        <Voucher program={'cnhpop'} registrationId={'123123'} />
      </ErrorBoundary>
    </>
  );
}
